import React from "react";
import { motion } from "framer-motion";

const TransitionWrapper = ({ children, onAnimationStart, onAnimationComplete }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
      style={{ width: "100%" }}
      onAnimationStart={(definition) => {
        // Notifier le parent que l'animation démarre
        if (onAnimationStart) {
          onAnimationStart(definition);
        }
      }}
      onAnimationComplete={(definition) => {
        // Si c'est l'animation d'entrée, on nettoie les styles qui peuvent gêner position: fixed
        if (definition.opacity === 1) {
          document.querySelectorAll(".page-transition-container").forEach((el) => {
            el.style.transform = "none";
          });
        }
        
        // Notifier le parent que l'animation est terminée
        if (onAnimationComplete) {
          onAnimationComplete(definition);
        }
      }}
      className="page-transition-container"
    >
      {children}
    </motion.div>
  );
};

export default TransitionWrapper;
